import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LeaderDonor } from "types";
import { fetchDonorLeaderboard } from "./campaignLeaderDonors.actions";
import { initialState } from "./campaignLeaderDonors.initial-state";

const campaignLeaderDonorsSlice = createSlice({
  name: "campaignLeaderDonors",
  initialState,
  reducers: {
    setDonorLeaderboard: (state, action: PayloadAction<LeaderDonor[]>) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDonorLeaderboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDonorLeaderboard.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchDonorLeaderboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch donor leaderboard";
      });
  },
});

export const { setDonorLeaderboard } = campaignLeaderDonorsSlice.actions;
const campaignLeaderDonorsReducer = campaignLeaderDonorsSlice.reducer;
export default campaignLeaderDonorsReducer;
